const lbaDynamic = angular.module('app.lbaDynamic', []);

lbaDynamic.directive('lbaDynamic', require('./lbaDynamicDir'));

export default lbaDynamic;



// WEBPACK FOOTER //
// ./src/components/lbaDynamic/index.js